import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import { X, Check } from 'react-bootstrap-icons'
import Select from 'react-select'
import USER_ROLES from '../../../constants/user-roles'
import { get, find } from 'lodash'
import { useMutation } from 'react-query'
import userService from '../../../services/api/user'
import useToasts from '../../../hooks/use-toasts'
import useUsers from '../../../hooks/use-users'

const EditRole = ({
    user = {},
    onClose = () => {}
}) => {
    const options = Object.keys(USER_ROLES).map(key => ({
        label: key,
        value: USER_ROLES[key]
    }))

    const [ roles, setRoles] = useState(get(user, 'rolesCode', '').split('').map(value => find(options, { value })))
    
    const rolesCode = (roles || []).map(r => r.value).join('')

    const { error: errorToast } = useToasts({
        errorMessage: 'Error updating user.'
    })

    const { reloadUsers } = useUsers({ enabled: false, onReload: onClose })

    const [ updateUser, { isLoading }] = useMutation(() => userService.update({ id: user.id, rolesCode }), {
        onError: errorToast,
        onSuccess: reloadUsers
    })


    return (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ flexGrow: '0.9', color: 'black' }}>
                <Select
                    isLoading={isLoading}
                    isDisabled={isLoading}
                    value={roles}
                    isMulti
                    name="colors"
                    options={options}
                    className="basic-multi-select form-control-sm"
                    classNamePrefix="select"
                    onChange={setRoles}
                    placeholder='Select Roles'
                />
            </div>
            <div style={{ display: 'flex', alignItems: 'center'}}>
                <Button disabled={isLoading} variant='outline-secondary' onClick={() => onClose()} ><X /></Button>
                <Button disabled={isLoading} variant='primary' onClick={() => updateUser()} ><Check /></Button>
            </div>
        </div>
    )
}

export default EditRole